/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { Cart } from '@msdyn365-commerce/retail-proxy';
import { lAC_SetOrderNoteAsync } from '../custom-actions/DataActionExtension.g';
import { ILAC_AuthToken } from '../custom-actions/DataServiceEntities.g';
import { withFreshToken } from '../utils/authService';

/**
 * SetOrderNote Input Action
 */
export class SetOrderNoteInput implements Msdyn365.IActionInput {
    public authTokenCookie: ILAC_AuthToken;
    public cartId: string;
    public customerId: string;
    public note: string;

    constructor(cartId: string, note: string, customerId: string, authTokenCookie: ILAC_AuthToken) {
        this.authTokenCookie = authTokenCookie;
        this.cartId = cartId;
        this.customerId = customerId;
        this.note = note;
    }

    public getCacheKey = () => `LACSETORDERNOTE${this.cartId}`;
    public getCacheObjectType = () => 'LACSETORDERNOTE';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * Sets the order's note on the guest's cart.
 */
async function setOrderNoteAsync(input: SetOrderNoteInput, ctx: Msdyn365.IActionContext): Promise<Cart | undefined> {
    return withFreshToken(ctx, input.authTokenCookie, async carried =>
        lAC_SetOrderNoteAsync({ callerContext: ctx }, carried, input.cartId, input.customerId, input.note)
    );
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<Cart | undefined>>setOrderNoteAsync,
    id: 'LACSetOrderNote'
});
